import React from 'react'

export default function Success() {
  return (
    <div className="text-white text-center">
      <h1 className="text-5xl pt-6 mb-4">Success!</h1>
      <p className="text-xl">Now go and play</p>
    </div>
  )
}
